<div v-if="formulare.length"><formular-liste-box-item v-for="formular in formulare" :key="formular.pk" :formular="formular"></formular-liste-box-item></div>